import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { NAV_ITEMS, isNavItemActive } from './navConfig';

/**
 * BottomTabs — the mobile nav (≤760px; the side nav hides via CSS).
 * Same items as SideNav, icon + short label, 44px+ touch targets.
 */
const BottomTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  return (
    <nav className="ft-bottomtabs">
      {NAV_ITEMS.filter((item) => !item.requiresRole || user?.role === item.requiresRole).map((item) => {
        const active = isNavItemActive(item, location.pathname);
        const ItemIcon = item.icon;
        return (
          <button
            key={item.key}
            className={`ft-bottomtab${active ? ' on' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <ItemIcon />
            <span>{item.shortLabel || item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomTabs;
